import GoogleLogo from '../assets/img/google_g.svg';
import MicrosoftLogo from '../assets/img/microsoft_logo.svg';

// General
export const appEnvironment = process.env.REACT_APP_FYI_ENV; // web, chrome
export const appStage = process.env.REACT_APP_STAGE; // local, dev, prod
export const appVersion: any = process.env.REACT_APP_VERSION; // x.x.x
export const baseRoute = process.env.REACT_APP_ROOT_PATH;
export const restApiUrl = process.env.REACT_APP_API_URL;
export const graphqlApiUrl = process.env.REACT_APP_GRAPHQL_URL;
export const wsApiUrl = process.env.REACT_APP_WEBSOCKET_URL;
export const organizationDomainSuffix = process.env.REACT_APP_ORGANIZATION_DOMAIN_SUFFIX;

export enum LoadingStatusType {
  LOADING = 'LOADING',
  LOADED = 'LOADED',
  ERROR = 'ERROR',
}

// Tracking
export const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
export const sentryRelease = process.env.REACT_APP_SENTRY_RELEASE;
export const datadogToken = process.env.REACT_APP_DATADOG_CLIENT_TOKEN as string;
export const datadogAppId = process.env.REACT_APP_DATADOG_APPLICATION_ID as string;
export const amplitudeKey = process.env.REACT_APP_AMPLITUDE_KEY as string;
export const siteblimpKey = process.env.REACT_APP_SITEBLIMP_KEY as string;

// Chrome Extension
export const chromeExtensionId = process.env.REACT_APP_CHROME_EXTENSION_ID;
export const isChromeExtension = appEnvironment === 'chrome' ? true : false;

// Authentication
export const ipApiKey = process.env.REACT_APP_IP_API_KEY;
export const microsoftAuthCode = process.env.REACT_APP_MICROSOFT_AUTH_CODE;
export const webAppRoot = process.env.REACT_APP_WEB_APP_ROOT;
export const marketingUrl = process.env.REACT_APP_MARKETING_URL;

export const providers: ProviderData = {
  google: {
    id: 'google',
    name: 'Google',
    imagePath: GoogleLogo,
  },
  microsoft: {
    id: 'microsoft',
    name: 'Microsoft',
    imagePath: MicrosoftLogo,
  },
};

// Avatar
export type CollaboratorAvatarSize =
  | 'Small'
  | 'SubStandard'
  | 'Medium'
  | 'Large'
  | 'XL'
  | 'XXL'
  | 'Enormous';
export type CollaboratorAvatarType = 'Person' | 'Group' | 'OrgGroup';

// Navigation
export const chromeInstallUrl =
  appStage !== 'prod'
    ? `https://chrome.google.com/webstore/detail/${chromeExtensionId}`
    : 'http://bit.ly/fyichrome';

// Images
export const specialIntegrationImageType = {
  provider: 'provider',
};

// Groups
export enum GroupTypes {
  CUSTOM = 'custom',
  OTHER_PEOPLE = 'other_people',
  ORGANISATION = 'organization',
}

// Profile
export enum OrganizationTypes {
  WORK = 'work',
  PERSONAL = 'personal',
}

export enum ProfileFeedType {
  ALL = 'all',
  OWNED = 'owned',
  SHARED = 'shared',
}

// Settings

export enum SettingsTabsType {
  APPS = 'apps',
  MEMBERS = 'members',
}

// Text Input
export type InputSize = 'Default' | 'AltDefault' | 'Small' | 'Medium';

// Integrations
export const maxIntegrationsWithGroups = 3;
export const maxIntegrationsNoGroups = 10;

// Impersination mode
export const inImpersonateMode = sessionStorage.getItem('impersonateModeActive') ? true : false;
